import { MonoTypeOperatorFunction, pipe } from 'rxjs';
import { map } from 'rxjs/operators';

type Sort<T> = (a: T, b: T) => number;

export function sort<T>(sortFn: Sort<T>): MonoTypeOperatorFunction<T[]> {
  return pipe(map((list: T[]) => list.sort(sortFn)));
}
